class HomeSlideshowSlider extends HTMLElement {
  connectedCallback() {
    const splideSlider = this.querySelector('splide-slider')
    if (!splideSlider) return

    // 检查 Splide 是否已经初始化
    if (splideSlider.slider) {
      this.initSlider(splideSlider.slider)
    } else {
      // 如果还没初始化，监听 splide:loaded 事件
      splideSlider.addEventListener('splide:loaded', e => {
        this.initSlider(e.detail.slider)
      })
    }
  }

  // 初始化 Splide 实例
  initSlider(slider) {
    this.slider = slider
    // 绑定切换事件
    this.slider.on('move', () => this.updatePaginationColor())
  }

  // 更新分页颜色
  updatePaginationColor() {
    if (!this.slider) return

    // 只查询原始的 slides，排除 Splide 克隆的 slides
    const slides = this.querySelectorAll('.splide__slide:not(.splide__slide--clone)')
    const activeSlide = slides[this.slider.index]

    if (activeSlide) {
      const colorActive = activeSlide.dataset.paginationColorActive
      const color = activeSlide.dataset.paginationColor

      if (colorActive) this.style.setProperty('--pagination-color-active', colorActive)
      if (color) this.style.setProperty('--pagination-color', color)
    }
  }
}

//  注册自定义元素
if (!customElements.get('home-slideshow-slider')) {
  customElements.define('home-slideshow-slider', HomeSlideshowSlider)
}
